import { createSlice } from '@reduxjs/toolkit';
import { register, updateUser, update, login, profile, me } from './authAPI';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        walletAddress: null,
        username: null,
        email: null,
        isCivic: null,
        telegramUsername: null,
        chatId: null,
        mal: null,
        nal: null,
        cs: null,
        createdAt: null,
        updatedAt: null,
        user: { username: "User", isCivic: "INACTIVE", cs: 20, createdAt: new Date("1999-11-25T00:00:00.000+00:00") },
        status: 'idle',
        error: null,
    },
    reducers: {
        logout: (state) => {
            state.walletAddress = null;
            state.username = null;
            state.email = null;
            state.isCivic = null;
            state.telegramUsername = null;
            state.chatId = null;
            state.mal = null;
            state.nal = null;
            state.cs = null;
            state.createdAt = null;
            state.updatedAt = null;
            state.user = { username: "User", isCivic: "INACTIVE", cs: 20, createdAt: new Date("1999-11-25T00:00:00.000+00:00") };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(register.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(register.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.walletAddress = action.payload.walletAddress;
                state.username = action.payload.username;
                state.email = action.payload.email;
                state.isCivic = action.payload.isCivic;
                state.telegramUsername = action.payload.telegramUsername;
                state.chatId = action.payload.chatId;
                state.mal = action.payload.mal;
                state.nal = action.payload.nal;
                state.cs = action.payload.cs;
                state.createdAt = action.payload.createdAt;
                state.updatedAt = action.payload.updatedAt;
            })
            .addCase(register.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            .addCase(login.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(login.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.walletAddress = action.payload.walletAddress;
                state.username = action.payload.username;
                state.email = action.payload.email;
                state.isCivic = action.payload.isCivic;
                state.telegramUsername = action.payload.telegramUsername;
                state.chatId = action.payload.chatId;
                state.mal = action.payload.mal;
                state.nal = action.payload.nal;
                state.cs = action.payload.cs;
                state.createdAt = action.payload.createdAt;
                state.updatedAt = action.payload.updatedAt;
            })
            .addCase(login.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            .addCase(update.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(update.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.walletAddress = action.payload.walletAddress;
                state.username = action.payload.username;
                state.email = action.payload.email;
                state.isCivic = action.payload.isCivic;
                state.telegramUsername = action.payload.telegramUsername;
                state.chatId = action.payload.chatId;
                state.mal = action.payload.mal;
                state.nal = action.payload.nal;
                state.cs = action.payload.cs;
                state.createdAt = action.payload.createdAt;
                state.updatedAt = action.payload.updatedAt;
            })
            .addCase(update.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            .addCase(updateUser.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateUser.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.walletAddress = action.payload.walletAddress;
                state.username = action.payload.username;
                state.email = action.payload.email;
                state.isCivic = action.payload.isCivic;
                state.telegramUsername = action.payload.telegramUsername;
                state.chatId = action.payload.chatId;
                state.mal = action.payload.mal;
                state.nal = action.payload.nal;
                state.cs = action.payload.cs;
                state.createdAt = action.payload.createdAt;
                state.updatedAt = action.payload.updatedAt;
            })
            .addCase(updateUser.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            .addCase(me.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(me.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.walletAddress = action.payload.walletAddress;
                state.username = action.payload.username;
                state.email = action.payload.email;
                state.isCivic = action.payload.isCivic;
                state.telegramUsername = action.payload.telegramUsername;
                state.chatId = action.payload.chatId;
                state.mal = action.payload.mal;
                state.nal = action.payload.nal;
                state.cs = action.payload.cs;
                state.createdAt = action.payload.createdAt;
                state.updatedAt = action.payload.updatedAt;
            })
            .addCase(me.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            .addCase(profile.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(profile.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.user.username = action.payload.username;
                state.user.isCivic = action.payload.isCivic;
                state.user.cs = action.payload.cs;
                state.user.createdAt = action.payload.createdAt;
            })
            .addCase(profile.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
